import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const ProjectCard = ({ project }) => {
  const { language, t } = useLanguage();
  
  const title = language === 'tr' ? project.title_tr : project.title_en;
  const description = language === 'tr' ? project.short_desc_tr : project.short_desc_en;
  
  const imageUrl = project.image ? 
    (project.image.startsWith('http') ? project.image : `${API_URL}${project.image}`) : 
    null;

  const getLinkDisplayText = (url) => {
    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      return url;
    }
  };

  return (
    <motion.div
      whileHover={{ y: -4 }}
      className="bg-white rounded-xl border border-gray-100 shadow-corporate overflow-hidden h-full flex flex-col"
    >
      {/* Image */}
      {imageUrl && (
        <div className="aspect-video overflow-hidden bg-gray-100">
          <img 
            src={imageUrl} 
            alt={title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      
      {/* Content */}
      <div className="p-6 flex-1 flex flex-col">
        <h3 className="text-lg font-semibold text-bms-text mb-2">
          {title}
        </h3>
        <p className="text-bms-text-light text-sm mb-4 flex-1 line-clamp-2">
          {description}
        </p>
        
        <Link 
          to={`/projeler/${project.slug}`}
          className="inline-flex items-center gap-1 text-bms-primary text-sm font-medium hover:gap-2 transition-all"
        >
          <span>{t.projects.viewDetails}</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
        
        {/* External Project Link */}
        {project.link && (
          <div className="mt-4 pt-4 border-t border-gray-100">
            <span className="text-bms-text-muted text-sm">Siteyi ziyaret et → </span>
            <a 
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-bms-primary hover:underline text-sm font-medium"
              data-testid="project-external-link"
            >
              {getLinkDisplayText(project.link)}
              <ExternalLink className="w-3 h-3" />
            </a>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProjectCard;
